import { HOME_FAQ } from './faq.js';

/**
 * The homepage FAQ.
 *
 * Rendered as open `<details>` content rather than a JavaScript accordion so the answers are present
 * in the DOM for any reader, including assistive technology and any crawler that executes the page.
 * The authoritative structured-data copy of these same questions is emitted by the server-rendered
 * homepage as FAQPage JSON-LD.
 */
export function HomeFaq() {
  return (
    <section className="mt-10" aria-labelledby="faq">
      <h2 id="faq" className="mb-4 text-h3 font-bold text-text-primary sm:text-h2">
        Common questions
      </h2>
      <div className="divide-y divide-border-subtle overflow-hidden rounded-md border border-border-subtle bg-bg-raised">
        {HOME_FAQ.map((item) => (
          <details key={item.q} className="group px-4 py-3" open>
            <summary className="cursor-pointer list-none text-sm font-semibold text-text-primary marker:hidden">
              {item.q}
            </summary>
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-text-secondary">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
